import { render, staticRenderFns } from "./Breadcrumb2.vue?vue&type=template&id=7ec28370&scoped=true&"
import script from "./Breadcrumb2.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb2.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumb2.vue?vue&type=style&index=0&id=7ec28370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec28370",
  null
  
)

export default component.exports